import gql from 'graphql-tag';

export default gql`
    mutation SaveUser($input: SaveUserInput) {
        saveUser(input: $input) {
            errors
        }
    }
`;
